/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { Channel } from './Channel';

export class Channels {
    /**
     * Unique identifier of this result set. Will be populated with client sent Origin-RequestId.
     */
    callId: string;

    /**
     * List of channels available to the client.
     */
    channels: Channel[];

    /**
     * The latest time change(s) made to the channels.
     */
    snapshotVersion: number;

    constructor(params) {
        this.callId = params.callId;
        this.channels = params.channels || [];
        this.snapshotVersion = params.snapshotVersion;
    }
}
